import {
  PossibleTagsVal,
  toGroupTagsArgs,
} from '@components/TagDialog/TagDialog.utils';
import { createStyles } from '@mantine/core';
import { RelatedTagsList } from '@pages/Updates/components/UpdatesNew/components/RelatedTagsList/RelatedTagsList';
import {
  DivFwd,
  HovercardDivProps,
} from '@pages/Updates/components/UpdatesNew/components/RelatedTagsList/RelatedTagsList.types';
import { forwardRef } from 'react';

const useStyles = createStyles(() => {
  return {
    tags: {
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      height: '100%',
    },
  };
});
interface TagsListProps extends HovercardDivProps {
  tags: PossibleTagsVal;
}
function FWTagsList(props: TagsListProps, ref: DivFwd) {
  const { tags, className, ...rest } = props;
  const { classes, cx } = useStyles();
  const c_tags = cx(classes.tags, className);
  const tagLen = tags.length;

  return (
    <div ref={ref} className={c_tags} {...rest} hidden={tagLen === 0}>
      <RelatedTagsList
        tags={toGroupTagsArgs(tags)[0]}
        className="TagsList_responsive"
      />
    </div>
  );
}
export const TagsListInventory = forwardRef(FWTagsList);
